<template>
	<div class="menu-container">
		<div class="navbar-white" ref="navbar">
			<Navbar
				class="desktop-center"
				:logoSrc="$logoSrc"
				:backButton="false"
			/>
		</div>
		<div class="navbar-page menu-page-container">
			<div class="menu-page" @scroll.passive="handleMenuScroll">
				<Banner
					:title="bannerTitle"
					:src="bannerImage"
					:showSubtitle="false"
				/>
				<div v-if="!loading" class="menu-page-content">
					<OfflineWidgetAlt v-if="showOffline" />
					<ComingSoonSection v-if="showComingSoon" />
					<slot v-if="showMenu">
						<HorizontalNavbar
							ref="brandNavbar"
							class="desktop-center brand-navbar"
							:isSticky="navbarSticky"
							:stickyEnabled="navbarSticky"
							:options="menuTabs"
							:stickyOffset="0"
							:filterButton="true"
							@optionSelected="tabClicked"
						/>
						<CategorizedMenu
							ref="categorizedMenuRef"
							:categorizedMenu="categorizedMenu"
						/>
					</slot>
				</div>
				<div v-if="showMenu">
					<Footer @openCartSummary="openCartSummary" />
				</div>
			</div>
			<FloatingCartSummary ref="cartSummary" />
		</div>
		<ItemModal ref="itemModal" />
	</div>
</template>

<style scoped>
.brand-navbar {
	height: 50px !important;
	margin-bottom: 10px !important;
}

.brand-navbar >>> .option-nav {
	border-bottom-left-radius: 5px;
	border-bottom-right-radius: 5px;
}

.menu-section-title {
	margin: 5px auto !important;
	padding-left: 10px;
}

.menu-page {
	padding-left: 0;
	padding-right: 0;
	overflow-x: hidden;
}

.button {
	max-width: 186px;
}
</style>

<script>
import { eventBus } from "@/eventBus"
import { EventBusEvents } from "@/enums/EventBusEvents"
import menuMixin from "@/mixins/menu-mixin"
import menuCategoriesMixin from "@/mixins/menu-categories-mixin"
import Navbar from "@/components/navbars/Navbar.vue"
import Banner from "@/components/Banner.vue"
import MenuItem from "@/components/menu/MenuItem.vue"
import Footer from "@/components/Footer.vue"
import ComingSoonSection from "@/components/menu/ComingSoonSection.vue"
import OfflineWidgetAlt from "@/components/menu/OfflineWidgetAlt.vue"
import FloatingCartSummary from "@/components/common/FloatingCartSummary.vue"
import HorizontalNavbar from "@/components/common/HorizontalNavbar.vue"
import CategorizedMenu from "@/components/menu/CategorizedMenu.vue"
import ItemModal from "@/components/modals/ItemModal.vue"

export default {
	name: "AirportMenu",
	mixins: [menuMixin, menuCategoriesMixin],
	components: {
		Banner,
		MenuItem,
		Navbar,
		Footer,
		CategorizedMenu,
		ItemModal,
		ComingSoonSection,
		OfflineWidgetAlt,
		FloatingCartSummary,
		HorizontalNavbar
	},
	data: function () {
		return {
			categoriesScrollToOffset: -100,
			navbarSticky: false
		}
	},
	mounted: function () {
		this.trackOutOfStock()
		this.trackComingSoon()
		if (this.$route.query.brandId && this.menuTabs) {
			const tab = this.menuTabs.find(
				(tab) => tab.id == this.$route.query.brandId
			)
			if (tab) {
				this.tabClicked({
					id: tab.id,
					text: tab.text,
					deeplink: true
				})
				this.$refs.brandNavbar.scrollToSelectedOption(tab)
			}
		}
	},
	methods: {
		startPreorder() {
			eventBus.emit(EventBusEvents.OPEN_MENU_TIME_MODAL, {
				date: this.$store.state.deliveryDate
			})
		},
		openCartSummary() {
			this.$refs.cartSummary.open()
		},
		handleMenuScroll() {
			const brandNavbar = this.$refs.brandNavbar
			const navbar = this.$refs.navbar
			if (brandNavbar && brandNavbar.$el && navbar) {
				const rect = brandNavbar.$el.getBoundingClientRect()
				const navbarRect = navbar.getBoundingClientRect()
				this.navbarSticky = rect.top <= navbarRect.height + 1
			}
		}
	},
	computed: {
		categorizedMenuRefKey() {
			return "categorizedMenuRef"
		},
		bannerTitle() {
			return this.selectedMenuTab ? this.selectedMenuTab.text : ""
		},
		bannerImage() {
			if (this.selectedMenuTab) {
				const brand = this.$store.state.brands.find(
					(brand) => this.selectedMenuTab.id == brand.id
				)
				if (brand) {
					return `${process.env.VUE_APP_BASE_BRANDS_IMAGE_URL}${brand.id}/${brand.img}`
				}
			}
			return null
		}
	}
}
</script>

